import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import LandingPageView from '../components/LandingPage/LandingPage';
import * as landingPageService from '../services/landingPageService';
import { normalizeLandingConfig } from '../services/landingPageService';

export default function LandingPage() {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const refSlug = searchParams.get('ref');

  const [landingData, setLandingData] = useState(null);
  const [landingAgent, setLandingAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isActive = true;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      const { data, error: fetchError } = await landingPageService.getPublicLandingPageData(eventId);
      if (!isActive) return;

      if (fetchError || !data?.event) {
        setError(fetchError || { message: 'Event not found.' });
        setLoading(false);
        return;
      }

      const { data: agent } = await landingPageService.resolvePublicLandingAgent({
        eventId,
        refSlug,
        eventAgentId: data.event.agent_id ?? data.event.agentId,
      });
      if (!isActive) return;

      setLandingAgent(agent);
      setLandingData({ ...data, agent, ref_slug: refSlug });
      setLoading(false);
    };

    fetchData();
    return () => {
      isActive = false;
    };
  }, [eventId, refSlug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-slate-200 border-t-emerald-600 rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-600 font-medium">Loading event...</p>
        </div>
      </div>
    );
  }

  if (!landingData?.event || error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center max-w-md px-4">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Event Not Found</h1>
          <p className="text-slate-600">The event you&apos;re looking for doesn&apos;t exist or isn&apos;t available.</p>
        </div>
      </div>
    );
  }

  const {
    event,
    sessions = [],
    learning_objectives = [],
    faqs = [],
    testimonials = [],
    bonuses = [],
    instructors = [],
    landing_page,
  } = landingData;

  const config = normalizeLandingConfig(landing_page);

  return (
    <LandingPageView
      event={event}
      sessions={sessions}
      learningObjectives={learning_objectives}
      faqs={faqs}
      testimonials={testimonials}
      bonuses={bonuses}
      instructors={instructors}
      theme={config.theme}
      density={config.density}
      heroStyle={config.hero_style}
      refSlug={refSlug}
    />
  );
}
